// Canonical client-side year and date-range constants used by diagnostics/map UI.
// If you change year values here, ensure they still align with server-side
// DIAGNOSTIC_ANALYSIS_PERIOD in libs/constants/src/lib/diagnostic.constants.ts.
import { DIAGNOSTIC_ANALYSIS_PERIOD } from '@wri-monorepos/constants';
export var latestTreeCoverLossYearForTclDataInMap = DIAGNOSTIC_ANALYSIS_PERIOD.END_YEAR;
export var latestTreeCoverLossYearCommodityRisk = DIAGNOSTIC_ANALYSIS_PERIOD.COMMODITY_RISK_END_YEAR;
export var earliestTreeCoverLossYearCommodityRisk = 2002;
export var latestTreeCoverLossYearForTclDataInAnalyses = DIAGNOSTIC_ANALYSIS_PERIOD.END_YEAR;
var todayIso = new Date().toISOString().split('T')[0];
var defaultStartYear = latestTreeCoverLossYearForTclDataInMap + 1;
var startIso = "".concat(defaultStartYear, "-01-01");
export var soyPlantedYearsRange = { from: 2001, to: 2024 };
export var prodesYearsRange = {
    from: DIAGNOSTIC_ANALYSIS_PERIOD.PRODES_START_YEAR,
    to: DIAGNOSTIC_ANALYSIS_PERIOD.PRODES_END_YEAR,
};
export var dcfAlertsDateRange = {
    min: '2020-01-01',
    initialStart: "".concat(latestTreeCoverLossYearForTclDataInMap + 1, "-01-01"),
    max: todayIso,
};
export var deforestationAlertDateRange = {
    startDate: startIso,
    endDate: todayIso,
    minDate: "".concat(latestTreeCoverLossYearForTclDataInMap + 1, "-01-01"),
    maxDate: todayIso,
};
export var disturbanceAlertsVegetationTypes = {
    AllVegetation: 'all-vegetation',
    TreeCover: 'tree-cover',
};
